import clsx from "clsx";
import { ReactMarkdown } from "react-markdown/lib/react-markdown";

/* eslint-disable-next-line */
export interface LRichTextProps {
  id?: string;
  type: "ComponentCmsDataRichText" | "ComponentCmsDataRichTextHtml";
  richText: string;
  centerText?: boolean;
  fullWidth?: boolean;
  backgroundImage?: {
    url: string;
    altTag: string;
  };
}

export function LRichText(props: LRichTextProps) {
  return (
    <div
      id={props?.id}
      className="bg-eklight"
      style={
        props?.backgroundImage?.url
          ? {
              backgroundImage: `url("${props?.backgroundImage?.url}")`,
              backgroundPosition: "top center",
              backgroundSize: "cover",
            }
          : { backgroundImage: "none" }
      }
    >
      <div
        className={clsx([
          props?.centerText && "text-center",
          props?.fullWidth ? "w-full" : "container lg:max-w-7xl",
          " px-4 py-2 mx-auto",
        ])}
      >
        {props?.type === "ComponentCmsDataRichTextHtml" ? (
          <div
            className="rich-text-component"
            dangerouslySetInnerHTML={{ __html: props?.richText }}
          />
        ) : (
          <ReactMarkdown>{props?.richText}</ReactMarkdown>
        )}
      </div>
    </div>
  );
}

export default LRichText;
